module.exports = __webpack_public_path__ + "static/grbmember6-4d72293e4d64070ddf7c760861122322.jpg";